import {useState} from "react";
import {isNullOrUndefined} from "../../../../services/Validator";
import {useResizeListener} from "../../../../listeners/SystemResizeListener";
import ExerciserResultsAppreciationDialog from "../../../dialogs/courses/exercisers/ExerciserResultsAppreciationDialog";
import ExerciserResultsTotalScore from "./ExerciserResultsTotalScore";
import ExerciserResultsScoreEmojiImage from "../../../images/courses/exercisers/ExerciserResultsScoreEmojiImage";

export default function ExerciserResultsScore({correctAnswers, total}) {
    // Used in ResultsScreen component to display
    // flash score

    // PROPERTIES
    const [isAppreciationModalOpen, setIsAppreciationModalOpen] = useState(false)
    let successRatio = (isNullOrUndefined(correctAnswers) || isNullOrUndefined(total)) ? null : Math.round(100*correctAnswers/total)

    // HOOKS
    // ---- Eventually close modal during screen resize
    useResizeListener(() => setIsAppreciationModalOpen(false))

    // BUILD
    if (isNullOrUndefined(successRatio))
        return null;
    return (
        <div className="w-[112px] min-w-[112px] h-full flex flex-col items-center">
            {/** MODAL */}
            <ExerciserResultsAppreciationDialog open={isAppreciationModalOpen}
                                                handleClose={() => setIsAppreciationModalOpen(false)}
                                                successRatio={successRatio} />
            {/** CORE */}
            <ExerciserResultsTotalScore correctAnswers={correctAnswers}
                                        total={total} />
            <ExerciserResultsScoreEmojiImage successRatio={successRatio}
                                             openAppreciation={() => setIsAppreciationModalOpen(true)} />
        </div>
    );
}